<template>
    <div>
        <el-form label-position="right" ref="form" :model="form.model" :rules="formRules"
                 :validate-on-rule-change="false" label-width="120px">
            <el-row>
                <el-row class="column-name" justify="start">
                    <span>基本信息</span>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="是否总公司" prop="corporation">
                                <dictionary-select v-model="form.model.corporation" :disabled="parentDisabled || !formEditable"
                                                   :factory-name="'domain'" :params="'YNTYPE'"
                                                   :clearable="true" size="small">
                                </dictionary-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="所属公司" prop="parentId">
                                <company-select ref="companyAll" v-show="parentDisabled || !formEditable"
                                                v-model="form.model.parentId"
                                                :disabled="true"
                                                :clearable="true" :filterable="true" size="mini">
                                </company-select>
                                <company-select ref="company" v-show="!(parentDisabled || !formEditable)"
                                                v-model="form.model.parentId"
                                                :disabled="false"
                                                :clearable="true" :filterable="true" size="mini">
                                </company-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="公司编号" prop="code">
                                <el-input v-model="form.model.code" @input="handleCodeInput" :disabled="!formEditable" :maxlength="30" :show-word-limit="true" size="small"/>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="公司名称" prop="name">
                                <el-input v-model="form.model.name" @input="handleNameInput" :disabled="!formEditable" :maxlength="60" :show-word-limit="true" size="small"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="状态" prop="status">
                                <dictionary-select :factory-name="'domain'" :params="'COMPANYSTATUS'"
                                                   v-model="form.model.status" :disabled="true"
                                                   :default-first-by-only-one="false" size="small">
                                </dictionary-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="公司负责人" prop="leaderId">
                                <dictionary-select v-show="!formEditable" :factory-name="'org_person'" :params="{type: 'ALL'}"
                                                   v-model="form.model.leaderId" :disabled="true"
                                                   :default-first-by-only-one="false"
                                                   :clearable="true" :filterable="true" size="small">
                                </dictionary-select>
                                <dictionary-select v-show="formEditable" :factory-name="'org_person'" :params="{type: 'NOT_QUIT'}"
                                                   v-model="form.model.leaderId" :disabled="false"
                                                   :default-first-by-only-one="false"
                                                   :clearable="true" :filterable="true" size="small">
                                </dictionary-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="法人" prop="corporateId">
                                <dictionary-select v-show="!formEditable" :factory-name="'org_person'" :params="{type: 'ALL'}"
                                                   v-model="form.model.corporateId" :disabled="true"
                                                   :default-first-by-only-one="false"
                                                   :clearable="true" :filterable="true" size="small">
                                </dictionary-select>
                                <dictionary-select v-show="formEditable" :factory-name="'org_person'" :params="{type: 'NOT_QUIT'}"
                                                   v-model="form.model.corporateId" :disabled="false"
                                                   :default-first-by-only-one="false" @change="handleCorporateIdChange"
                                                   :clearable="true" :filterable="true" size="small">
                                </dictionary-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="SHR数据" prop="syncFromShr">
                                <el-switch
                                        v-model="form.model.syncFromShr" :disabled="!formEditable" size="small"
                                        active-text="同步"
                                        inactive-text="不同步"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="form.model.id != null">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="创建用户" prop="createUserId">
                                <user-input :id="form.model.createUserId" :disabled="true" size="small"/>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="创建时间" prop="createUserId">
                                <el-date-picker v-model="form.model.createTime"
                                                :disabled="true" type="datetime" size="small">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="form.model.id != null">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="修改用户" prop="createUserId">
                                <user-input :id="form.model.lastUpdateUserId" :disabled="true" size="small"/>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="修改时间" prop="createUserId">
                                <el-date-picker v-model="form.model.lastUpdateTime"
                                        :disabled="true" type="datetime" size="small">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import {merge} from "@/util"
    import {
        PAGE_STATUS_DETAIL_ADD,
        PAGE_STATUS_DETAIL_EDIT,
        PAGE_STATUS_DETAIL_SHOW
    } from "@/views/organization/company/company.common";

    import {AuthInfo} from "@/util/user/authInfo";
    import OrganizationServer from "@/api/organization";
    import {createNamespacedHelpers} from "vuex";
    import DictionarySelect from "@/components/common/DictionarySelect";
    import CompanySelect from "@/views/organization/company/company-select";
    import UserInput from "@/components/common/user-input";
    import OrganizationCheck from '@/views/organization/mixins/organization-check';

    const CurrentRestResource = OrganizationServer.company;

    const companyForm = createNamespacedHelpers("organization/company/form");

    export default {
        name: "company.form",
        components: {DictionarySelect, CompanySelect, UserInput},
        props: {
            value: {},
        },
        mixins: [OrganizationCheck],
        data() {
            return {
                parentDisabled: false,
            };
        },
        computed: {
            ...companyForm.mapState(['operation', 'form']),
            formRules() {
                let corporation = [
                    {required: true, message: '请选择是否总公司', trigger: 'change'},
                ];
                let parentId = [
                    {required: String(this.form.model.corporation) === '0', message: '请选择上级公司', trigger: 'change'},
                ];
                return {
                    corporation: corporation,
                    parentId: parentId,
                    code: [
                        {required: true, message: '请输入公司编号', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                CurrentRestResource.findByCode(value).then(res => {
                                    if (res.data.code === '200') {
                                        if (res.data.data != null && (this.form.model.id == null || this.form.model.id !== res.data.data.id)) {
                                            callback(new Error('公司编号已存在'));
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        callback(new Error('校验公司编号出错' + res.data.message));
                                    }
                                }, error => {
                                    callback(new Error('校验公司编号出错' + error));
                                });
                            },
                            trigger: 'blur',
                        },
                    ],
                    name: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                        {min: 1, max: 60, message: '长度在 1 到 60 个字符', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                CurrentRestResource.findByName(value).then(res => {
                                    if (res.data.code === '200') {
                                        if (res.data.data != null && (this.form.model.id == null || this.form.model.id !== res.data.data.id)) {
                                            callback(new Error('公司名称已存在'));
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        callback(new Error('校验公司名称出错' + res.data.message));
                                    }
                                }, error => {
                                    callback(new Error('校验公司名称出错' + error));
                                });
                            },
                            trigger: 'blur',
                        },
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'},
                    ],
                    leaderId: [
                        {required: true, message: '请选择公司负责人', trigger: 'change'},
                    ],
                };
            },
            formEditable() {
                return (this.operation === PAGE_STATUS_DETAIL_EDIT || this.operation === PAGE_STATUS_DETAIL_ADD);
            },
        },
        watch: {
            'form.model.corporation': {
                immediate: true,
                handler() {
                    let corporation = this.form.model.corporation;
                    if (String(corporation) === '1') {
                        this.form.model.parentId = null;
                    }
                },
            },
            'form.model.parentId': {
                immediate: true,
                handler() {
                    let parentId = this.form.model.parentId;
                    if (parentId != null) {
                        this.form.model.corporation = '0';
                    }
                },
            },
            /*'form.model.corporateId': {
                immediate: true,
                handler() {
                    let corporateId = this.form.model.corporateId;
                    if (corporateId != null) {
                        this.form.model.leaderId = corporateId;
                    }
                },
            },*/
        },
        methods: {
            ...companyForm.mapMutations(['setOperation', 'setFormModel']),
            handleCorporateIdChange(data) {
                let corporateId = data[0];
                if (corporateId != null && corporateId !== '') {
                    this.form.model.leaderId = corporateId;
                }
            },
            handleCodeInput() {
                this.form.model.code = this.formatOrganizationCode(this.form.model.code);
            },
            handleNameInput() {
                this.form.model.name = this.formatOrganizationName(this.form.model.name);
            },
            async loadCompany() {
                await this.$nextTick();
                return this.$refs.company.load({
                    ne_id: this.form.model.id,
                    ne_parentId: this.form.model.id,
                    eq_status: '1'
                });
            },
            async queryFormModel(id) {
                let res = await CurrentRestResource.get(id);
                if (res.data.code !== '200') {
                    this.$message.error(res.data.message);
                    return;
                }
                let model = res.data.data;
                model.status = '' + model.status;
                return Promise.resolve(model);
            },
            setDisabled(options) {
                if (options != null) {
                    this.parentDisabled = options.parentDisabled === true;
                } else {
                    this.parentDisabled = false;
                }
            },
            async toAdd(data, options) {
                this.setDisabled(options);
                if (this.$refs.form != null) {
                    this.$refs.form.resetFields();
                }
                let formModel = {
                    id: null,
                    corporation: null,
                    parentId: null,
                    code: null,
                    name: null,
                    status: '1',
                    leaderId: null,
                    corporateId: null,
                    syncFromShr: false,

                    orgId: null,
                    parentOrgId: null,
                };
                formModel = merge(true, {}, formModel, data);
                this['setFormModel'](formModel);
                this['setOperation'](PAGE_STATUS_DETAIL_ADD);
            },
            async toShow(id) {
                let formModel = await this.queryFormModel(id);
                this['setFormModel'](formModel);
                this['setOperation'](PAGE_STATUS_DETAIL_SHOW);
                return Promise.resolve(this.form.model);
            },
            async toEdit(id, options) {
                this.setDisabled(options);
                let formModel = await this.queryFormModel(id);
                this['setFormModel'](formModel);
                this['setOperation'](PAGE_STATUS_DETAIL_EDIT);
                return Promise.resolve(this.form.model);
            },
            async saveAdd() {
                let validated = await this.$refs.form.validate();
                if (validated) {
                    let data = this.form.model;
                    data.createUserId = AuthInfo.userId;
                    let response = await CurrentRestResource.add(this.form.model);
                    if (response.data.code === "200") {
                        this.$message.success(response.data.message || '保存成功！');
                        this.$emit('save-success', response.data.data);
                    } else {
                        this.$message.error(response.data.message || '保存失败！');
                    }
                }

            },
            async saveEdit() {
                let validated = await this.$refs.form.validate();
                if (validated) {
                    let response = await CurrentRestResource.update(this.form.model.id, this.form.model);
                    if (response.data.code === "200") {
                        this.$message.success(response.data.message || '保存成功！');
                        this.$emit('save-success', response.data.data);
                    } else {
                        this.$message.error(response.data.message || '保存失败！');
                    }
                }
            },
        },
        created() {
            this.loadCompany();
        },
    }
</script>

<style scoped>

</style>